(function () {
  'use strict';
  var dlg = document.getElementById('NavDrawer');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  function open() { dlg.classList.remove('is-closing'); dlg.showModal(); document.documentElement.style.overflow = 'hidden'; }
  function close() {
    if (!dlg.open) return;
    dlg.classList.add('is-closing');
    setTimeout(function () { dlg.close(); dlg.classList.remove('is-closing'); document.documentElement.style.overflow = ''; }, 250);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-nav-close]')) { close(); return; }
    if (e.target === dlg) { close(); return; }
    if (e.target.closest('.nd__link, .nd__brand')) { document.documentElement.style.overflow = ''; }
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
})();
